// Base SimpleMap Class
export class SimpleMap {
    constructor(targetDivId, settings = {}) {
        this.map = {} // create clone of map object
        this.targetDivId = targetDivId // id of div into which map is loaded
        this.settings = settings // additional settings avaialble to the widget, outlined in documentation
    }

    init() {
        this.map.mapdata.main_settings.div = this.targetDivId // update settings with target div
        this.map.load() // load map onto the page in the target div
    }

    createMap() {
        this.map = this.#deepClone(simplemaps_usmap) // create clone of map object
        this.map.create() // create new map instance
        this.map.mapdata.main_settings = {...this.map.mapdata.main_settings, ...this.settings} // update map settings
    }

    // creates deep clone of object passed in, preserving methods and other data types
    #deepClone(obj) {
        if (typeof obj !== "object" || Array.isArray(obj) || obj === null) {
            return obj;
        }
        
        let clone = {};
        for (let key in obj) {
            clone[key] = this.#deepClone(obj[key]);
        }
        
        return clone;
    }

    // add metro pins to map
    addMetros(metros) {
        if(JSON.stringify(metros) !== "{}") {
            this.map.mapdata.locations = metros
        }
    }

    // map outline and labeling attrirbutes required for WCAG
    resetMapOutline(mapContainerId) {
        let $mapContainer = $('#' + mapContainerId)
        $mapContainer.css('outline', '').attr({
            'aria-label': 'Map',
            'role': 'region'
        });
    }

    // add dropdown field labels required for WCAG
    addSelectorLabels(parentId) {
        const $parent = $('#' + parentId)
        const $children = $parent.find('select')
        
        $children.each((index, child) => {
            const $child = $(child)
            if($child.find('option:first').text() === 'Navigate') {
                $child.addClass('d-none')
            } else {
                const childId = `map-nav-${index}`
                const labelText = $child.find('option:first').text()
                const $label = $('<label>').attr({'for': childId, 'class': 'sr-only'}).text(labelText)

                $child.attr('id', childId)
                $label.insertBefore($child)
            }
        })
    }
}
